var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 120,
    viewBox: "0 0 106 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4198 49.469L63.2317 54.1557L52.998 48.303V38.941L71.4198 49.469Z",
    fill: "#007DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0017 38.941V48.303L42.7623 54.1557L34.5742 49.469L53.0017 38.941Z",
    fill: "#007DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4198 49.469L63.2317 54.1557L52.998 48.303V38.941L71.4198 49.469Z",
    fill: "url(#paint0_linear_592_3643)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0017 38.941V48.303L42.7623 54.1557L34.5742 49.469L53.0017 38.941Z",
    fill: "url(#paint1_linear_592_3643)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4198 49.469L63.2317 54.1557L52.998 48.303V38.941L71.4198 49.469Z",
    fill: "url(#paint2_linear_592_3643)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0017 81.0621V71.7001L42.7623 65.8531L34.5742 70.5341L53.0017 81.0621Z",
    fill: "#007DF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.998 81.0621L71.4198 70.5341L63.2317 65.8531L52.998 71.7001V81.0621Z",
    fill: "#007DF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.998 81.0621L71.4198 70.5341L63.2317 65.8531L52.998 71.7001V81.0621Z",
    fill: "url(#paint3_linear_592_3643)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0017 81.0621V71.7001L42.7623 65.8531L34.5742 70.5341L53.0017 81.0621Z",
    fill: "url(#paint4_linear_592_3643)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5742 70.5043L43.6931 65.2944L34.5742 64.5038V70.5043Z",
    fill: "#007DF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5742 50.0105V59.7991L42.9117 54.8052L34.5742 50.0105Z",
    fill: "#007DF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4351 60.377V70.1655L63.0977 65.166L71.4351 60.377Z",
    fill: "#007DF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5742 59.7932L63.086 65.1624L71.4234 60.3734L42.9117 54.7994L34.5742 59.7932Z",
    fill: "#007DF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 29.9968L61.8418 54.5848H105.5V29.9968Z",
    fill: "#007DF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.998 0V26.6697L82.1591 43.3347L105.494 29.997L52.998 0Z",
    fill: "#007DF2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0014 0L0.5 29.997L23.8403 43.3347L53.0014 26.6697V0Z",
    fill: "#007DF2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 29.9968V90.0079L23.8403 76.6702V43.3345L0.5 29.9968Z",
    fill: "#007DF2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8403 76.6594L53.0014 93.3244V120L0.5 89.9971L23.8403 76.6594Z",
    fill: "#007DF2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1591 76.6594L105.494 89.9971L52.998 120V93.3244L82.1591 76.6594Z",
    fill: "#007DF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.998 0V26.6697L82.1591 43.3347L105.494 29.997L52.998 0Z",
    fill: "url(#paint5_linear_592_3643)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8403 76.6594L0.5 89.9971L53.0014 120V93.3244L23.8403 76.6594Z",
    fill: "url(#paint6_linear_592_3643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_592_3643",
    x1: 57.4685,
    y1: 42.092,
    x2: 67.7994,
    y2: 57.1948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_592_3643",
    x1: 45.8307,
    y1: 47.6944,
    x2: 29.8675,
    y2: 56.8149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_592_3643",
    x1: 55.8021,
    y1: 44.1908,
    x2: 85.6647,
    y2: 66.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_592_3643",
    x1: 52.998,
    y1: 73.4576,
    x2: 71.4198,
    y2: 73.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_592_3643",
    x1: 48.5313,
    y1: 77.9054,
    x2: 38.2004,
    y2: 62.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_592_3643",
    x1: 65.7312,
    y1: 8.9809,
    x2: 95.177,
    y2: 52.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_592_3643",
    x1: 0.5,
    y1: 98.3296,
    x2: 53.0014,
    y2: 98.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e8a391fdb12d44ebb18071c6dbf0614.svg";
export { ForwardRef as ReactComponent };